<template>
  <StartComponent v-if="!started" @start="start"></StartComponent>
  <template v-else-if="gameStore.currentPage<lastPage">
    <p>Si tu número aparece, pulsa Sí, en caso contrario pulsa No</p>
    <PageComponent
      :seed="seed"
    ></PageComponent>
    <ButtonComponent
      @yes="yes"
      @no="no"
    ></ButtonComponent>
    <p>Pantalla {{ gameStore.currentPage + 1}} / {{ lastPage }}</p>
  </template>
  <template v-else>
    <template v-if="gameStore.thoughtNumber <= 64 && gameStore.thoughtNumber >= 0">
      <span>El número que has pensado es</span> <h1>{{ gameStore.thoughtNumber - seed }}</h1>
    </template>
    <template v-else>
      <span>Has ido demasiado rápido, no te pillo... Prueba de nuevo anda...</span>
    </template>
    <p>
      <button @click="restart">Reiniciar</button>
    </p>
  </template>
</template>

<script>
import StartComponent from '@/components/StartComponent.vue'
import PageComponent from '@/components/PageComponent.vue'
import ButtonComponent from '@/components/ButtonComponent.vue'

import { useGameStore } from './stores/game'

export default {
  name: 'App',
  emits: ['yes', 'no'],
  data(){
    return {
      started: false,
      lastPage: 6,
      seed: null,
    }
  },
  setup() {
    const gameStore = useGameStore()
    return { gameStore }
  },
  methods: {
    start(){
      this.started = true
    },
    restart(){
      this.started = false
      this.gameStore.resetCurrentPage()
      this.gameStore.thoughtNumber = 0
      this.seed = this.generateRandomSeed();
    },
    yes(){
      this.gameStore.incrementThoughtNumber(Math.pow(2, this.gameStore.currentPage))
      this.gameStore.incrementCurrentPage()
    },
    no(){
      this.gameStore.incrementCurrentPage()
    },
    generateRandomSeed(){
      let max = 64 - 50;
      return Math.floor(Math.random() * max);
    }
  },
  mounted(){
    this.seed = this.generateRandomSeed();
  },
  components: {
    StartComponent,
    PageComponent,
    ButtonComponent
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
